import React from 'react';
import Icon from '../../../components/AppIcon';
import ActionLogsTable from './ActionLogsTable';

const SafetyMonitoringTab = () => {
  const safetyStats = [
    {
      label: 'Total Reports',
      value: '247',
      change: '+12%',
      trend: 'up',
      icon: 'AlertTriangle',
      color: 'error'
    },
    {
      label: 'Resolved Cases',
      value: '198',
      change: '+8%',
      trend: 'up',
      icon: 'CheckCircle',
      color: 'success'
    },
    {
      label: 'Active Users',
      value: '1,234',
      change: '+5%',
      trend: 'up',
      icon: 'Users',
      color: 'primary'
    },
    {
      label: 'Suspended Accounts',
      value: '23',
      change: '-3%',
      trend: 'down',
      icon: 'Ban',
      color: 'warning'
    },
    {
      label: 'Verified Users',
      value: '892',
      change: '+15%',
      trend: 'up',
      icon: 'BadgeCheck',
      color: 'success'
    },
    {
      label: 'Avg Response Time',
      value: '2.4h',
      change: '-12%',
      trend: 'down',
      icon: 'Clock',
      color: 'primary'
    }
  ];

  const getColorClasses = (color) => {
    switch (color) {
      case 'error':
        return 'bg-error/10 text-error';
      case 'success':
        return 'bg-success/10 text-success';
      case 'warning':
        return 'bg-warning/10 text-warning';
      case 'primary':
        return 'bg-primary/10 text-primary';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getTrendColor = (trend) => {
    return trend === 'up' ? 'text-success' : 'text-error';
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-heading font-semibold mb-1">Platform Safety Overview</h3>
        <p className="text-sm text-muted-foreground">Real-time monitoring and statistics</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {safetyStats?.map((stat, index) => (
          <div key={index} className="bg-card rounded-xl shadow-warm p-4 border border-border">
            <div className="flex items-start justify-between mb-3">
              <div className={`p-2 rounded-lg ${getColorClasses(stat?.color)}`}>
                <Icon name={stat?.icon} size={20} />
              </div>
              <span className={`text-xs font-medium ${getTrendColor(stat?.trend)}`}>
                {stat?.change}
              </span>
            </div>
            <p className="text-2xl font-bold mb-1">{stat?.value}</p>
            <p className="text-sm text-muted-foreground">{stat?.label}</p>
          </div>
        ))}
      </div>

      <div className="bg-card rounded-xl shadow-warm p-6 border border-border">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Icon name="Shield" size={20} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="text-lg font-heading font-semibold">Safety Score</h3>
            <p className="text-sm text-muted-foreground">Overall platform health</p>
          </div>
        </div>
        <div className="flex items-end gap-4">
          <div className="text-5xl font-bold text-success">87</div>
          <div className="flex-1 pb-2">
            <div className="h-4 bg-muted rounded-full overflow-hidden">
              <div className="h-full bg-gradient-to-r from-success to-primary" style={{ width: '87%' }} />
            </div>
            <p className="text-xs text-muted-foreground mt-2">Excellent - Platform is secure and well-monitored</p>
          </div>
        </div>
      </div>

      <ActionLogsTable />
    </div>
  );
};

export default SafetyMonitoringTab;